import {Button} from '@mantine/core';
import {
  ENTRY_BUTTON_ID,
  ENTRY_BUTTON_TEXT_SIZE,
  GradientEntryButton,
} from '../../../../shared/components/EntryButton/GradientEntryButton';

export const EntryButtonPC = ({
  entryURL,
  registrationURL,
  size = 'lg',
  companyId,
  companyName,
}: {
  entryURL?: string;
  registrationURL?: string;
  size?: 'lg' | 'base';
  companyId?: number;
  companyName?: string;
}) => {
  if (!entryURL && !registrationURL) {
    return null;
  }

  const buttonSize =
    size === 'base' ? ENTRY_BUTTON_TEXT_SIZE.BASE : ENTRY_BUTTON_TEXT_SIZE.LG;
  const sizedStyle = size === 'base' ? 'h-40 w-[180px]' : 'h-48 w-[240px]';

  return (
    <div className="hidden pc:block text-center">
      {entryURL && entryURL.length > 0 && (
        <div className="inline-block mt-8">
          <GradientEntryButton
            id={ENTRY_BUTTON_ID.COMPANY_ENTRY_MAIN}
            entryUrl={entryURL}
            size={buttonSize}
            className={sizedStyle}
            withShadow
            companyId={companyId}
            companyName={companyName}
          />
        </div>
      )}
      {registrationURL && registrationURL.length > 0 && (
        <Button
          className={`bg-white text-primary-1 border-primary-1 rounded-[8px] mx-auto mt-8 block pc:hover:ease-in-out pc:hover:duration-300 ${sizedStyle}`}
          id="company_entry_fair_button_main"
          onClick={() =>
            window.open(`${registrationURL}`, '_blank', 'noopener,noreferrer')
          }
        >
          説明会を予約
        </Button>
      )}
    </div>
  );
};
